<script>
	import { goto } from '@roxi/routify';
	import { successToast, warningToast, failureToast } from '../components/toast.js'
	import { getData, postFormData, postJsonData } from "../helpers.js";
	import { startAuthentication } from "@simplewebauthn/browser";

	function authenticateWebauthn(challenge_id, authn_options, passkey=false) {
		// Pass the options to the authenticator and wait for a response
		let optionsJSON = authn_options;
		console.log(optionsJSON);
		let response = startAuthentication({ optionsJSON });
		response.catch(error => {
			// Some basic error handling
			if (passkey) passkeyAuthenticateError = error;
			else passwordLoginError = error;
			throw error;
		}).then(asseResp => {
			return postJsonData('webauthn/validate-authentication',
				{'challenge_id': challenge_id, 'options': authn_options, 'asseResp': asseResp})
		}).then(verificationResp => verificationResp.json())
		.then(verificationJson => {
			if (verificationJson && verificationJson.verified) {
				$goto('./dashboard');
			} else {
				let error = `Oh no, something went wrong! Response: ${JSON.stringify(verificationJson)}`
				if (passkey) passkeyAuthenticateError = error;
				else passwordLoginError = error;
			}
		}).catch(error => {
			if (passkey) passkeyAuthenticateError = error;
			else passwordLoginError = error;
		});
	};

	let loginForm;
	let usernameLoginError = '';
	let passwordLoginError = '';
	// handle login form submission and response
	function handleLogin() {
		let res = postFormData('webauthn/login-webauthn-check', loginForm);
		res.then(response => response.json())
		.then(ret_json => {
			if (ret_json.status === 'success') {
				if (ret_json.webauthn) {
					authenticateWebauthn(ret_json.challenge_id, JSON.parse(ret_json.webauthn_options), false);
				} else {
					$goto('./dashboard');
				}
			} else if (ret_json.status === 'error') {
				let errors = ret_json.error;
				usernameLoginError = errors.username ? errors.username[0] : '';
				passwordLoginError = errors.password ? errors.password[0] : '';
			}
		});
	}

	let passkeyAuthenticateError = '';
	function passkeyAuthenticate() {
		let res = getData('webauthn/authentication-options');
		res.then(response => response.json())
		.then(ret_json => {
			authenticateWebauthn(ret_json.challenge_id, JSON.parse(ret_json.webauthn_options), true);
		}).catch(error => {
			passkeyAuthenticateError = error;
		})
	}

	let passwordlessAuthenticateError = '';
	function passwordlessAuthenticate() {
		let res = postFormData('user/passwordless-login-request', loginForm)
		res.then(response => response.json())
		.then(ret_json => {
			if (ret_json.status === 'success') {
				successToast('If we recognize that information, we\'ve emailed you a login link.');
			} else if (ret_json.status === 'error') {
				let errors = ret_json.error;
				usernameLoginError = errors.username ? errors.username[0] : '';
			} else {
				failureToast('An unknown error occured.');
			}
		}).catch(error => {
			passwordlessAuthenticateError = error;
		})
	}
</script>

<main class=background>
	<div class="py-14 px-6 text-center text-6xl font-bold font-mono">
		<img class="mx-auto h-20" src="./ref/padg_lockup.svg" alt="Palo Alto Data Group Logo">
	</div>
	<div class="flex max-w-max mx-auto pb-4">
		<div class="inline-flex flex-col px-2 items-center">
			<div class="card px-8 py-8 lg:px-16 lg:py-16">
				<p class="text-2xl font-semibold text-blue-900 mb-8">eCPR Search</p>
				<form method="POST" class="flex-col" bind:this={loginForm} on:submit|preventDefault={handleLogin}>
					<div class="flex flex-col space-y-6 text-xl h-full box-border">
						<div class="input">
							<div class="relative">
								<input id="username-login" name="username" placeholder="Username" autocomplete="webauthn username" class="peer z-20 placeholder:text-transparent {usernameLoginError === '' ? '' : 'border-red-600'}"/>
								<label for="username-login" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">Username</label>
							</div>
							<p class='error-text {usernameLoginError === '' ? 'hidden' : ''}'>{usernameLoginError}</p>
						</div>
						<div class='input'>
							<div class="relative">
								<input id="password-login" name="password" type="password" placeholder="Password" class="peer z-20 placeholder:text-transparent {passwordLoginError === '' ? '' : 'border-red-600'}"/>
								<label for="password-login" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">Password</label>
							</div>
							<p class='error-text {passwordLoginError === '' ? 'hidden' : ''}'>{passwordLoginError}</p>
							<div class="flex justify-end mt-1">
								<a href="/forgot-password" class="text-sm">Forgot Password?</a>
							</div>
						</div>
						<div class="flex space-x-4 justify-between">
							<div>
								<button type="submit"
									class="pb-3 pt-2 text-xl leading-5 px-4 rounded-md bg-blue-500 hover:bg-blue-600 cursor-pointer text-gray-100 font-semibold border-none shadow-sm">
									Log In
								</button>
							</div>
							<div class="tooltip-div">
								<button on:click|preventDefault={passkeyAuthenticate} class="{passkeyAuthenticateError === '' ? 'border-none' : 'border-2 border-red-600'} px-4 pb-3 pt-2 text-xl leading-5 rounded-md bg-blue-500 hover:bg-blue-600 cursor-pointer text-gray-100 font-semibold border-none shadow-sm">
									Passkey
								</button>
								<p class='{passkeyAuthenticateError === '' ? 'hidden' : ''} tooltip'>{passkeyAuthenticateError}</p>
							</div>
							<!-- <button class="w-3/5 pb-3 pt-2 text-xl leading-5 !px-0 rounded-md bg-blue-500 hover:bg-blue-600 cursor-pointer text-gray-100 font-semibold border-none shadow-sm">
								WebAuthn
							</button> -->
						</div>
						<div class="tooltip-div mr-auto mt-8">
							<button on:click|preventDefault={passwordlessAuthenticate} class="{passwordlessAuthenticateError === '' ? 'border-none' : 'border-2 border-red-600'} px-4 pb-3 pt-2 text-xl leading-5 rounded-md bg-blue-500 hover:bg-blue-600 cursor-pointer text-gray-100 font-semibold border-none shadow-sm">
								Passwordless Login
							</button>
							<p class='{passwordlessAuthenticateError === '' ? 'hidden' : ''} tooltip'>{passwordlessAuthenticateError}</p>
						</div>
					</div>
				</form>
				<div class='w-full mt-10'>
					<a class="text-md lg:text-lg font-sans" href="/">
						<button class="bg-gray-100 bg-opacity-70 px-2 py-1 rounded-md shadow-sm">
							&lt;&lt; Back to Main Page
						</button>
					</a>
				</div>
			</div>
			<div class="flex mt-2 font-sans">
				<p class="my-6 m-auto text-gray-200">Copyright 2021-{new Date().getFullYear()} © Palo Alto Data Group</p>
			</div>
		</div>
	</div>
</main>

<style>
	.card {
		@apply rounded-md shadow-lg bg-gray-200 bg-opacity-50;
	}
	main.background {
		background:
			radial-gradient(farthest-side at top left,
				rgba(214, 238, 255, 0.773) 5%, transparent 95%),
			radial-gradient(farthest-side at bottom right,
				rgba(214, 238, 255, 0.773) 5%, transparent 95%);
		background-color:theme("colors.cust_blue.600");
	}
</style>